export default __webpack_public_path__ + "static/media/bg.d4f66d1a.jpg";